
/**
 * Admin List Product Display
 **/
import React, { Component } from 'react';
import { Row, Col, Container, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';


class AdminproductList extends Component {
    constructor(props) {
        super(props);
        this.toggleDelete = this.toggleDelete.bind(this);
        this.state = {
            open: false,
            modalDelete: false,
            stock: 'InStock',
            quantity: 1,
            image: ''
        }
    }

    toggleDelete() {
        this.setState(prevState => ({
            modalDelete: !prevState.modalDelete
        }));
    }
    onDeleteInvoicePopup() {
        this.toggleDelete();
    }
    render() {
        const { product, deleteproduct } = this.props;
        const variant = product.variants[0];

        return (


            <Col key={1} sm={6} lg={3}>
                <ToastContainer autoClose={1000} />
                <div className="product product_tag-black product-hover-style-default product-hover-button-style-light product_title_type-single_line product_icon_type-line-icon">
                    <div className="product-inner element-hovered">
                        <div className="product-thumbnail">
                            <div className="product-thumbnail-inner">
                                <Link to="#">
                                    {variant && variant.pictures[0] ?
                                        <div className="product-thumbnail-main">
                                            <img src={variant.pictures[0].url} className="img-fluid" />
                                        </div>
                                        :
                                        null
                                    }
                                    {variant && variant.pictures[1] ?
                                        <div className="product-thumbnail-swap">
                                            <img src={variant.pictures[1].url} className="img-fluid" />
                                        </div>
                                        :
                                        null
                                    }
                                </Link>
                            </div>
                            <div className="product-action product-action-quick-view">
                                <Link to={{
                                    pathname: `/admin-panel/product-create/${product._id}`,
                                }} className="open-edit-view"><i class="fa fa-pencil-square-o"></i></Link>
                                <Link to="#" className="product-delete" onClick={() => this.onDeleteInvoicePopup()} ><i class="fa fa-trash-o"></i></Link>
                            </div>
                            <div className="product-actions">
                            </div>
                        </div>
                        <div className="product-info">
                            {product.name ?
                                <h3 className="product-name">
                                    <Link to="#">{product.name}</Link>
                                </h3>
                                : null}
                            {product.salePrice ?
                                <span className="price">
                                    <ins>
                                        <span className="price-amount amount">
                                            <span className="currency-symbol">$</span>{product.salePrice}
                                        </span>
                                    </ins>
                                </span>
                                : <span className="price">
                                    <ins>
                                        <span className="price-amount amount">
                                            <span className="currency-symbol">$</span>{product.price}
                                        </span>
                                    </ins>
                                </span>}
                            {product.description ?
                                <div className="">
                                    <p>{product.description}
                                    </p>
                                </div>
                                : null}
                        </div>
                    </div>
                </div>


                {/* modal-delete */}
                <Modal isOpen={this.state.modalDelete} toggle={this.toggleDelete} className="modal-delete modal-lg modal-dialog-centered">
                    <ModalHeader toggle={this.toggleDelete}  ></ModalHeader>
                    <ModalBody>
                        Tem certeza em deletar esse produto ?
                        </ModalBody>
                    <ModalFooter className="justify-content-center pt-4" >
                        <Link className="action-button" onClick={(res) => deleteproduct(this.toggleDelete())}>Yes</Link>
                        <Link className="action-button no" onClick={this.toggleDelete}>No</Link>
                    </ModalFooter>
                </Modal>
            </Col>
        )
    }

}

export default AdminproductList;
